<p class="font-medium">{{data.typeSnack | titlecase }}</p>
<div class="content-style">{{data.message}}</div>
<div align="end">
        <button mat-stroked-button class="mat-stroked-button"
        (click)="snackBarRef.dismiss()">{{data.buttonText}}</button>
</div>
